import React from 'react';
import {connect} from "react-redux";
import {getFromHub} from '../actions/networkActions';
import ItineraryEntry from './ItineraryEntry';
import CruiseHeaderImage from "./CruiseHeaderImage";
import CruisesItineraryInfo from "./CruisesItineraryInfo";
import ThemableSvgIcon from "./theme/ThemableSvgIcon";
import {collapseAll, expandAll} from "../actions/itineraryActions";
import {imagePath} from "../utils/imageUtils";
import { Trans } from '@lingui/react/macro';
import { areRestaurantsEnabled, areActivitiesEnabled } from '../utils/configUtils';


class ItineraryOverview extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            nrRestaurants: 0,
            nrActivities: 0,
        }
    }

    componentDidMount() {
        getFromHub('prebooking/tac/config', this.updateConfig);
        getFromHub('prebooking/tac/templates/types/restaurant/availability', this.updateRestaurantsAvailability);
        getFromHub('prebooking/tac/templates/types/activity/availability', this.updateActivitiesAvailability);
    }

    updateConfig = config => {
        const payload = {
            isRestaurantsEnabled:  areRestaurantsEnabled() ? config.diningEnabled : false,
            isRestaurantsBookingEnabled:  areRestaurantsEnabled() ? config.diningBookingEnabled : false,
            isActivitiesEnabled:  areActivitiesEnabled() ? config.activityEnabled : false,
            isActivitiesBookingEnabled:  areActivitiesEnabled() ? config.activityBookingEnabled : false,
        };
        this.props.dispatch({ type: 'SET_TAC_CONFIG', payload });
    }

    updateRestaurantsAvailability = (restaurantsAvailabilityByDate) => {
        const availabilityByDate = restaurantsAvailabilityByDate || {};
        const nrRestaurants = new Set(Object.values(availabilityByDate).flat().map(entry => entry.id)).size;

        this.setState({
            nrRestaurants,
        });
        
        this.props.dispatch({ type: 'SET_TAC_RESTAURANTS_AVAILABILITY', payload: availabilityByDate });
    }

    updateActivitiesAvailability = (activitiesAvailabilityByDate) => {
        const availabilityByDate = activitiesAvailabilityByDate || {};
        const nrActivities = new Set(Object.values(availabilityByDate).flat().map(entry => entry.id)).size;

        this.setState({
            nrActivities,
        });

        this.props.dispatch({ type: 'SET_TAC_ACTIVITIES_AVAILABILITY', payload: availabilityByDate });
    }

    calculateNrExcursions = () => {
         return this.props.itinerary.reduce((sum, itineraryElement) => {
             return sum + itineraryElement.numberOfBookableExcursions;
         }, 0);
    };

    countItineraryItems = (itineraryId, itineraryDate) => {
        let count = 0;
        if(this.props.bookings.excursions.hasOwnProperty(itineraryId)) {
            count += Object.keys(this.props.bookings.excursions[itineraryId]).length;
        }

        if(this.props.cartExcursions.hasOwnProperty(itineraryId)) {
            count += Object.keys(this.props.cartExcursions[itineraryId]).length;
        }

        if(this.props.bookings.tac.hasOwnProperty(itineraryDate)) {
            count += Object.keys(this.props.bookings.tac[itineraryDate]).length;
        }

        if(this.props.cartTac.hasOwnProperty(itineraryDate)) {
            count += Object.keys(this.props.cartTac[itineraryDate]).length;
        }

        return count;
    };

    render() {
        const lastDayIndex = this.props.itinerary.length - 1;
        const nrItems = this.props.itinerary.map(day => this.countItineraryItems(day.id, day.date));
        const showExpandAll = (this.props.itinerary.findIndex((day, index) => (day.expanded === false && nrItems[index] > 0)) > -1);
        const itineraryHasTenderPorts = (this.props.itinerary.findIndex(day => day.type === "TenderPort") > -1);

        return (
            <div>
                <div className="my-4 md:flex">
                    <div className="md:w-2/3 md:pr-2">
                        <CruiseHeaderImage />
                    </div>
                    <div className="pt-4 md:pt-0 md:w-1/3 md:pl-2 xl:flex xl:flex-col">
                        <CruisesItineraryInfo 
                            nrExcursions={this.calculateNrExcursions()} 
                            nrRestaurants={this.state.nrRestaurants} 
                            nrActivities={this.state.nrActivities}
                        />
                    </div>
                </div>
                <div className="text-primary-dark my-8">
                    <div className="flex">
                        <h2 className="grow">
                            <Trans id="your_itinerary">Your itinerary</Trans>
                        </h2>
                        {this.props.itineraryHasItems &&
                            <button className="text-primary" onClick={showExpandAll ? expandAll : collapseAll}>
                                {showExpandAll ? 
                                    <Trans id="expand_all">Expand all</Trans> : 
                                    <Trans id="collapse_all">Collapse all</Trans>
                                }
                                <ThemableSvgIcon name={showExpandAll ? "chevron-down" : "chevron-up"} className="w-6 h-6 inline ml-2"/>
                            </button>
                        }
                    </div>

                    <div className="my-4 text-primary-dark">
                        {this.props.itinerary.map((itineraryElement, index) =>
                            <ItineraryEntry
                                firstDay={index === 0}
                                lastDay={index === lastDayIndex}
                                key={itineraryElement.id}
                                nrItems={nrItems[index]}
                                {...itineraryElement} />
                        )}
                    </div>
                    {itineraryHasTenderPorts &&
                    <div className="my-4 flex items-center text-grey-dark">
                        <img className="inline-block mr-1 align-text-top" src={imagePath("icon_anchor.png")} alt="Tender port"/>
                        <Trans id="land_by_launch_or_tender">Land by launch or tender</Trans>
                    </div>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        itineraryHasItems: (state.bookings.nrExcursions > 0) || (state.cart.nrExcursions > 0),
        bookings: state.bookings,
        cartExcursions: state.cart.excursions ? state.cart.excursions : {},
        cartTac: state.cart.tac,
        itinerary: state.itinerary,
    }
}

export default connect(mapStateToProps) (ItineraryOverview);